import { mapToData } from 'src/common/http/mapToData';
import { mapToErrors } from 'src/common/http/mapToErrors';
import {
  CreateTriggerDTO,
  CreateTriggerResponse,
  TriggerDTO,
  UpdateTriggerDTO,
  UpdateTriggersUiSettingsDTO,
  UpdateTriggersUiSettingsResponseDTO,
} from 'src/modules/triggers/infra/dtos';

import instance from '../../../common/http/axiosInstance';

const requests = {
  get: async <T>(url: string): Promise<T> => instance.get(url).then(mapToData).catch(mapToErrors),
  post: async <T>(url: string, body: CreateTriggerDTO): Promise<T> =>
    instance.post(url, body).then(mapToData).catch(mapToErrors),
  patch: async <T, K>(url: string, body: T): Promise<K> => instance.patch(url, body).then(mapToData).catch(mapToErrors),
  delete: async <T>(url: string): Promise<T> => instance.delete(url).then(mapToData).catch(mapToErrors),
};

export const triggersService = {
  getById: async (projectId: string, triggerId: string): Promise<TriggerDTO> =>
    requests.get<TriggerDTO>(`projects/${projectId}/triggers/${triggerId}`),
  create: async (projectId: string, body: CreateTriggerDTO): Promise<CreateTriggerResponse> =>
    requests.post<CreateTriggerResponse>(`projects/${projectId}/triggers`, body),
  update: async (projectId: string, triggerId: string, body: UpdateTriggerDTO): Promise<void> =>
    requests.patch<UpdateTriggerDTO, void>(`projects/${projectId}/triggers/${triggerId}`, body),
  deleteTrigger: async (projectId: string, triggerId: string): Promise<void> =>
    requests.delete(`projects/${projectId}/triggers/${triggerId}`),
  updateUiSettings: async (
    projectId: string,
    body: UpdateTriggersUiSettingsDTO,
  ): Promise<UpdateTriggersUiSettingsResponseDTO> =>
    requests.patch<UpdateTriggersUiSettingsDTO, UpdateTriggersUiSettingsResponseDTO>(
      `projects/${projectId}/triggers/ui-settings`,
      body,
    ),
};
